import React from 'react'
import BEM from '@iui-kit/utils/bem'

const bem = new BEM(require('./InputGroup.css'))

interface Props {
  indent?: string
}

const InputGroup: React.FC<Props> = ({ indent, children }) => {
  return (
    <div
      className={bem
        .b('InputGroup')
        .m(indent)
        .show()}
    >
      {children}
    </div>
  )
}

export default InputGroup
